export const getUserObject = () => {
    const userObjectString = localStorage.getItem('user');

    const userObject = JSON.parse(userObjectString);

    return userObject;
}